import React from 'react';
import { Box, Text } from 'grommet';
import DatePicker from '../date-picker';
import {
  recencyFilterOptions,
  recencyFilters,
  getDatePeriodFromRecencyFilter
} from '../../reporting-utils';
import { FTSelect } from '../inputs';

const PeriodPicker = ({
  label = 'Period',
  recencyFilter,
  setRecencyFilter,
  customDatePeriod,
  setCustomDatePeriod
}) => {
  return (
    <Box direction='row' gap='xsmall' align='center' flex={{ shrink: 0 }}>
      <Text>{label}</Text>
      <Box flex={{ shrink: 0 }} style={{ width: '165px' }}>
        <FTSelect
          options={recencyFilterOptions}
          value={recencyFilter}
          onChange={optionValue => {
            if (optionValue !== recencyFilters.CUSTOM) {
              setCustomDatePeriod(getDatePeriodFromRecencyFilter(optionValue));
            }
            setRecencyFilter(optionValue);
          }}
        />
      </Box>
      <DatePicker
        dates={customDatePeriod}
        onSelect={dates => {
          setRecencyFilter(recencyFilters.CUSTOM);
          setCustomDatePeriod(dates);
        }}
      />
    </Box>
  );
};

PeriodPicker.displayName = 'PeriodPicker';

export default PeriodPicker;
